import { useState } from "react";
import { Copy, FileText } from "lucide-react";
import { toast } from "sonner";

export default function InvoiceDataPanel({ invoice, counterpartyRole }) {
  const [expanded, setExpanded] = useState(true);
  if (!invoice?.counterparty) return null;
  const c = invoice.counterparty;
  const copy = (val, label) => {
    if (!val) { toast.error("Campo vuoto"); return; }
    navigator.clipboard.writeText(val);
    toast.success(`${label} copiato`);
  };
  const rows = [
    ["Ragione sociale", c.business_name],
    ["P.IVA", c.vat_number],
    ["Codice fiscale", c.fiscal_code],
    ["Codice SDI", c.sdi_code],
    ["PEC", c.pec_email],
    ["Indirizzo", c.address],
    ["Email", c.email],
    ["Telefono", c.phone],
  ];
  return (
    <div className="ga-card p-5 mt-4 border-2 border-amber-200 bg-amber-50/30" data-testid="invoice-data-panel">
      <button onClick={() => setExpanded(v => !v)} className="w-full flex items-center justify-between gap-3 text-left">
        <div className="flex items-center gap-2">
          <FileText className="w-4 h-4 text-amber-700" />
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-amber-800">Dati di fatturazione</div>
            <div className="font-display text-base font-bold text-slate-900">
              {counterpartyRole === "supplier" ? "Fornitore vincitore" : "Cliente acquirente"}
            </div>
          </div>
        </div>
        <span className="text-xs text-slate-500">{expanded ? "− chiudi" : "+ apri"}</span>
      </button>
      {expanded && (
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
          {rows.filter(([, v]) => v).map(([label, val]) => (
            <div key={label} className="flex items-start justify-between gap-2 rounded-md bg-white px-3 py-2 border border-slate-200">
              <div className="min-w-0">
                <div className="text-[10px] font-mono uppercase tracking-wider text-slate-500">{label}</div>
                <div className="text-sm font-medium text-slate-900 truncate" title={val}>{val}</div>
              </div>
              <button onClick={() => copy(val, label)} className="shrink-0 text-slate-500 hover:text-slate-900 p-1" data-testid={`copy-invoice-${label.toLowerCase().replace(/\W+/g,'-')}`}>
                <Copy className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
